<template>
    <div class="choose-size" v-show="this.canSelectNum > 0">
        <p style="text-align: left;" :class="canSelectNum === selectedNum ? '' : 'error-msg'">
            因 {{ giveGoodsObj.goodsCode }} 请选择, 可选数量: {{ canSelectNum }} 已选数量:{{ selectedNum }}
        </p>
        <el-table border :data="selectedList" header-align="center" style="width: 100%">
            <el-table-column prop="code" align="center" :label="$t('BiGoods.goodsCode')"></el-table-column>
            <el-table-column prop="name" align="center" :label="$t('BiGoods.name')"></el-table-column>
            <el-table-column prop="pv" align="center" :label="$t('PV')"></el-table-column>
            <el-table-column prop="proPrice" align="center" :label="$t('pd.price')"></el-table-column>
            <el-table-column label="购买数量" width="200" align="center">
                <template slot-scope="{ row }">
                    <el-input-number v-model="row.quantity" size="mini" :min="0" style="width:100px;"
                        @change="quantityChange" />
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>

export default {
    name: 'ChooseSize',
    props: {
        value: {
            type: Object,
            default: () => {
                return {}
            }
        },
        //触发赠送的产品及赠送产品可选择的数量
        giveGoodsObj: {
            type: Object,
            default: () => {
                return {
                    goodsCode: '',
                    giveNum: 0
                }
            }
        },
        //购买的产品列表
        goodsList: {
            type: Array,
            default: () => {
                return []
            }
        },
        //可选择的产品列表
        selectedList: {
            type: Array,
            default: () => {
                return [
                    {
                        name: '健康磁性护腰(M)',
                        code: 'CN-T003-01-02',
                        quantity: 0,
                        point: 0,
                        price: 0,
                        proPrice: 0,
                        pv: 0,
                        isGive: 1,
                        gift: '是',
                        id: -50
                    }, {
                        name: '健康磁性护腰(L)',
                        code: 'CN-T003-01-03',
                        quantity: 0,
                        point: 0,
                        price: 0,
                        proPrice: 0,
                        pv: 0,
                        isGive: 1,
                        gift: '是',
                        id: -51
                    }, {
                        name: '健康磁性护腰(XL)',
                        code: 'CN-T003-01-04',
                        quantity: 0,
                        point: 0,
                        price: 0,
                        proPrice: 0,
                        pv: 0,
                        isGive: 1,
                        gift: '是',
                        id: -52
                    }, {
                        name: '健康磁性护腰(XXL)',
                        code: 'CN-T003-01-05',
                        quantity: 0,
                        point: 0,
                        price: 0,
                        proPrice: 0,
                        pv: 0,
                        isGive: 1,
                        gift: '是',
                        id: -53
                    }
                ]
            }
        },
    },
    data() {
        return {

        }
    },
    computed: {
        //可选数量
        canSelectNum() {
            let num = 0
            if (!this.goodsList.length) {
                return num
            }
            let good = this.goodsList.find(item => item.code === this.giveGoodsObj.goodsCode)

            if (good) {
                num = (good.quantity || good.buyQty) * this.giveGoodsObj.giveNum
            }
            return num
        },
        //已选数量
        selectedNum() {
            return this.selectedList.reduce((pre, cur) => {
                return pre + cur.quantity
            }, 0)
        },
    },
    watch: {
        canSelectNum: {
            immediate: true,
            handler(val) {
                console.log(val, 'canSelectNum');
                if (val === 0) {
                    this.$emit('input', {})
                }
            }
        },
        value: {
            immediate: true,
            deep: true,
            handler(val) {
                if (val.resList && val.resList.length > 0) {
                    this.selectedList.forEach(item => {
                        let obj = val.resList.find(item2 => item2.code === item.code)
                        if (obj) {
                            this.$set(item, 'quantity', obj.quantity)
                        }
                    })
                } else {
                    this.selectedList.forEach(item => {
                        this.$set(item, 'quantity', 0)
                    })
                }
            }
        }

    },
    methods: {
        quantityChange() {
            let inputObj = {
                selectedNum: this.selectedNum,
                resList: this.selectedList.filter(item => item.quantity > 0)
            }
            this.$emit('input', inputObj)
        }
    }


}
</script>

<style lang="scss" scoped>
.error-msg {
    color: red;
}
</style>